import { render } from "./EnBreadcrumbItem.vue?vue&type=template&id=03d29d84&ts=true"
import script from "./EnBreadcrumbItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnBreadcrumbItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/navigation/EnBreadcrumb/EnBreadcrumbItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03d29d84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03d29d84', __exports__)) {
    api.reload('03d29d84', __exports__)
  }
  
  module.hot.accept("./EnBreadcrumbItem.vue?vue&type=template&id=03d29d84&ts=true", () => {
    api.rerender('03d29d84', render)
  })

}


export default __exports__